import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate, useParams } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Grid,
  Chip,
  Box,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

// fetch
import { fetchProfile } from "../../utils/fetchProfile";
import patchData from "./Docs/notes";

// component
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";

export default function PatchDetail() {
  const navigate = useNavigate();
  const accessToken = Cookies.get("access_token") || "";

  const { id } = useParams();
  const patch = patchData.find((p) => p.id === id);

  const [isLoading, setIsLoading] = useState(false);
  const [dataProfile, setDataProfile] = useState([]);
  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(accessToken, setDataProfile, setNotAllowAccessPage, []);
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  if (notAllowAccessPage) {
    return (
      <div>
        <Navbar
          active="Patch Notes"
          initial={dataProfile.initial}
          role_code={dataProfile.role_code}
        />
        <div>Not allow to access this page</div>
      </div>
    );
  }

  return (
    <div>
      <Navbar
        active="Patch Notes"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      <Box
        sx={{
          width: { xs: "92%", sm: "90%", md: "70%", lg: "60%" },
          mx: "auto",
          mt: { xs: 4, sm: 6, md: 8 },
          px: { xs: "4%", sm: 3, md: 4 },
          mb: 20,
        }}
      >
        <Box
          display="flex"
          justifyContent="center"
          sx={{ marginTop: 12, gap: 1 }}
        >
          <Chip
            label="<"
            size="normal"
            sx={{
              bgcolor: `00000033`,
              color: "#000000",
              fontWeight: "light",
              textAlign: "center",
              fontSize: 18,
              "&:hover": {
                bgcolor: `#00000055`,
              },
              cursor: "pointer",
            }}
            onClick={() => window.close()}
          />
          {patch.type.map((type, index) => (
            <Chip
              key={index}
              label={type}
              size="normal"
              sx={{
                bgcolor: `${patch.color[index]}33`,
                color: patch.color[index],
                fontWeight: "bold",
                textAlign: "center",
                fontSize: 18,
              }}
            />
          ))}
        </Box>
        <Typography
          sx={{
            fontSize: 48,
            fontWeight: 800,
            fontFamily: "Montserrat",
            textAlign: "center",
          }}
        >
          {patch.title}
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ gap: 1, marginBottom: 12 }}
        >
          <CalendarMonthIcon />
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 400,
              fontFamily: "Montserrat",
              textAlign: "center",
              color: "#292929",
            }}
          >
            {patch.year}
          </Typography>
        </Box>
        <div style={{ padding: "2rem" }}>
          <p>{patch.description}</p>
          <hr />
          <div
            style={{
              border: "solid 1.5px #B6B6B5",
              backgroundColor: "#f8f8f8",
              padding: "15px 15px",
              borderRadius: 5,
              marginTop: "20px",
            }}
          >
            <h3 style={{ marginTop: 0 }}>💡 Changelog:</h3>
            <ul>
              {patch.changelog.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <Box
            sx={{
              position: "relative",
              pl: 4,
              mt: 4,
              "&::before": {
                content: '""',
                position: "absolute",
                left: 0,
                top: 0,
                bottom: 0,
                width: "2px",
                bgcolor: "#ccc",
              },
            }}
          >
            {patch?.datas.map((item, index) => (
              <Box
                key={index}
                sx={{
                  position: "relative",
                  mb: 6,
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    left: "-40px",
                    top: "6px",
                    width: "14px",
                    height: "14px",
                    bgcolor: "primary.main",
                    borderRadius: "50%",
                    border: "2px solid white",
                    zIndex: 1,
                  }}
                />
                {/* Content */}
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  {item.title} {item.date ? `-${" "}${item.date}` : ""}
                </Typography>
                <ul style={{ marginTop: 0, paddingLeft: "1rem" }}>
                  {item.items.map((subItem, subIndex) => (
                    <li key={subIndex} style={{ marginBottom: "8px" }}>
                      {subItem}
                    </li>
                  ))}
                </ul>
              </Box>
            ))}
          </Box>
        </div>
      </Box>
      <Footer />
    </div>
  );
}
